import { createApp } from 'vue';
import { defineRule, configure, ErrorMessage, Field, Form } from 'vee-validate';
import { required } from '@vee-validate/rules';
import { localize } from '@vee-validate/i18n';
import es from '@vee-validate/i18n/dist/locale/es.json';
import Swiper from 'swiper/bundle';
import UltravioletRays from '../../resources/js/components/UltravioletRays';
import CaloriesCalculator from '../../resources/js/components/CaloriesCalculator';
import SleepCalculator from '../../resources/js/components/SleepCalculator';
import anexobbvavideosnew from '../../resources/js/components/AnexoBbvaVideos';

defineRule('required', required);
('min_value', (value, [limit]) => {
  if (value >= limit) {
    return true;
  }
  return `El campo no es un número válido`;
});

configure({
  generateMessage: localize({
    es,
    custom: {
      Edad: {
        min_value: (fieldName) => `El campo ${fieldName} no es un número válido`,
      },
      Peso: {
        min_value: (fieldName) => `El campo ${fieldName} no es un número válido`,
      },
      Altura: {
        min_value: (fieldName) => `El campo ${fieldName} no es un número válido`,
      },
    },
  }),
  validateOnInput: true,
});

const app = createApp({});


app.component('ultravioletrays', UltravioletRays);
app.component('caloriescalculator', CaloriesCalculator);
app.component('sleepcalculator', SleepCalculator);
app.component('anexobbvavideosnew', anexobbvavideosnew);

app.mount('#app');

const slidesCount = document.querySelectorAll('.partner').length;

const partners = new Swiper('.partners', {
  slidesPerView: 2,
  loop: true,
  speed: 1000,
  breakpoints: {
    0: {
      slidesPerView: slidesCount <= 2 ? slidesCount : 2,
      loop: slidesCount <= 2 ? false : true,
      spaceBetween: 0,
    },
    768: {
      slidesPerView: slidesCount <= 4 ? slidesCount : 4,
      loop: slidesCount <= 4 ? false : true,
      spaceBetween: 0,
    },
    991: {
      slidesPerView: slidesCount <= 7 ? slidesCount : 7,
      loop: slidesCount <= 7 ? false : true,
      spaceBetween: 0,
    },
  },
});

const wh = window.innerWidth;
const runsRecursion =
  (wh < 768 && slidesCount <= 2) ||
    (wh > 768 && wh <= 991 && slidesCount <= 4) ||
    (wh > 991 && slidesCount <= 7)
    ? false
    : wh > 768 && wh <= 991 && slidesCount <= 4
      ? false
      : wh > 991 && slidesCount <= 7
        ? false
        : true;

if (runsRecursion) {
  const randomIntFromInterval = (min, max) =>
    Math.floor(Math.random() * (max - min + 1) + min);

  const recursion = () => {
    const random = randomIntFromInterval(1, partners.slides.length);
    partners.slideTo(random);

    setTimeout(recursion, 5000);
  };

  recursion();
}
